<template>
  <div>
    <div class="alcoholWarning">The Minister of Health warns: “Drinking alcohol can be harmful to health!”</div>
    <br/>  
    <input id="box1" type="checkbox" @change="check($event)" />
    <label for="box1"></label>
    <span>I confirm that I am of legal age (18+).</span>     
  </div>
</template>

<script>
export default {
  methods: {
    check($event) {
      this.$emit('check-disclaimer',  $event.target.checked)
    },
  },
  props: {
    type: String
  }
}
</script>

<style lang="css" scoped>

@import url(//netdna.bootstrapcdn.com/font-awesome/3.2.1/css/font-awesome.css);

/*** basic styles ***/

body { margin: 30px; } 
h1 { font-size: 1.5em; }
label { font-size: 24px; }
span { 
  font-size: 0.8em; 
}
div { 
  width: 90%; 
  margin-left: 20px;
  display: table-cell; 
  vertical-align: middle; 
}

.alcoholWarning {
  text-align: center;
  border: solid 1px var(--grey);
  color: var(--grey);
  padding: 5px;
  font-style: italic;
  margin-bottom: 20px;
  border-radius: 5px;
  background: var(--grey-superlight);
}

.colorLink {
  color: var(--bg) !important;
  text-decoration: underline;
}
.colorLink:hover {
  color: var(--primary) !important;
}
.colorLink:active {
  color: var(--primary) !important;
}

/*** custom checkboxes ***/

input[type=checkbox] { display:none; } /* to hide the checkbox itself */
input[type=checkbox] + label:before {
  font-family: FontAwesome;
  display: inline-block;
}

input[type=checkbox] + label:before { content: "\f096"; } /* unchecked icon */
input[type=checkbox] + label:before { letter-spacing: 10px; } /* space between checkbox and label */

input[type=checkbox]:checked + label:before { content: "\f046"; } /* checked icon */
input[type=checkbox]:checked + label:before { letter-spacing: 5px; } /* allow space for check mark */

</style>